<template>
  <div class="homocycle-ratio-warp" v-loading="loading">
    <el-row :gutter="20" class="h-100" v-if="obj">
      <el-col :span="6" class="h-100">
        <div class="box defalt-color bg-blue-color  v2-box-1">
          <div class="item-title">
            <label class="icon bg-defalt-color blue-color">
              <i class="el-icon-share"></i>
            </label>
            当前正向有功电度（kWh）
          </div>
          <div class="item-value">
            <label v-if="obj.activeEnergy === undefined">-</label>
            <countTo v-else :startVal="0" :endVal="parseFloat(obj.activeEnergy)" :decimals="2" :duration="1000"></countTo>
          </div>
          <div class="item-foot">
            <div class="item-foot-left">
              同比：{{ obj.activeEnergyYoYpercent || 0 }}%
              <div class="icon-item" v-if="obj.activeEnergyYoYpercent > 0">
                <i class="el-icon-top" style="color:red"></i>
              </div>
              <div class="icon-item" v-else-if="obj.activeEnergyYoYpercent < 0">
                <i class="el-icon-bottom" style="color:#04b39c"></i>
              </div>
              <div class="icon-item" style="color:#0097ee" v-else>
                =
              </div>
            </div>
            <div class="item-foot-right">
              环比：{{ obj.activeEnergyMoMpercent || 0 }}%
              <div class="icon-item" v-if="obj.activeEnergyMoMpercent > 0">
                <i class="el-icon-top" style="color:red"></i>
              </div>
              <div class="icon-item" v-else-if="obj.activeEnergyMoMpercent < 0">
                <i class="el-icon-bottom" style="color:#04b39c"></i>
              </div>
              <div class="icon-item" style="color:#0097ee" v-else>
                =
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="6" class="h-100">
        <div class="box defalt-color bg-green-color v2-box-2">
          <div class="item-title">
            <label class="icon bg-defalt-color green-color">
              <i class="el-icon-share"></i>
            </label>
            当前反向有功电度（kWh）
          </div>
          <div class="item-value">
            <label v-if="obj.activeEnergyR === undefined">-</label>
            <countTo v-else :startVal="0" :endVal="parseFloat(obj.activeEnergyR)" :decimals="2" :duration="1000"></countTo>
          </div>
          <div class="item-foot"></div>
        </div>
      </el-col>
      <el-col :span="6" class="h-100">
        <div class="box defalt-color bg-cyan-color  v2-box-3">
          <div class="item-title">
            <label class="icon bg-defalt-color cyan-color">
              <i class="el-icon-share"></i>
            </label>
            当前正向无功电度（kvar.h）
          </div>
          <div class="item-value">
            <label v-if="obj.reactiveEnergy === undefined">-</label>
            <countTo v-else :startVal="0" :endVal="parseFloat(obj.reactiveEnergy)" :decimals="2" :duration="1000"></countTo>
          </div>
          <div class="item-foot"></div>
        </div>
      </el-col>
      <el-col :span="6" class="h-100">
        <div class="box defalt-color bg-orange-color  v2-box-4">
          <div class="item-title">
            <label class="icon bg-defalt-color orange-color">
              <i class="el-icon-share"></i>
            </label>
            当前反向无功电度（kvar.h）
          </div>
          <div class="item-value">
            <label v-if="obj.reactiveEnergyR === undefined">-</label>
            <countTo v-else :startVal="0" :endVal="parseFloat(obj.reactiveEnergyR)" :decimals="2" :duration="1000"></countTo>
          </div>
          <div class="item-foot"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
import api from '../../../../../common/api/index'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      loading: true,
      obj: null
    }
  },
  components: { countTo },
  methods: {
    async getData(obj) {
      if (!obj.measureId) {
        return
      }
      let vm = this
      vm.loading = true
      const params = {
        measureId: obj.measureId,
        startTime: obj.startTime.replace(/-/g, '/'),
        endTime: obj.endTime.replace(/-/g, '/'),
        segments: [],
        pointCode: 100229,
        pointNumber: 0
      }
      const getParams = isCycle => {
        let endTime = obj.endTime
        if (endTime.includes('23:59:59')) {
          endTime = dayjs(obj.endTime).add(1, 'second').format('YYYY/MM/DD 00:00:00')
        }
        return {
        ...params,
        startTime: dayjs(obj.startTime)
          .subtract(1, isCycle ? obj.timeType : 'year')
          .format('YYYY/MM/DD 00:00:00'),
        endTime: dayjs(endTime)
          .subtract(1, isCycle ? obj.timeType : 'year')
          .format('YYYY/MM/DD 00:00:00')
        }
      }
      let timeType = obj.timeType
      if (timeType !== 'day') delete params.segments
      if (timeType === 'timeInterval') {
        timeType = 'hour'
      }
      const fn = api.quantity[`getQuantity${timeType[0].toLocaleUpperCase() + timeType.slice(1)}`]
      const valueObj = {}
      const [res, res1, res2, res3, res4, res5] = await Promise.all([
        fn(...Object.values(params)),
        fn(...Object.values(getParams())),
        fn(...Object.values(getParams(true))),
        fn(...Object.values({ ...params, pointCode: 100230 })),
        fn(...Object.values({ ...params, pointCode: 100231 })),
        fn(...Object.values({ ...params, pointCode: 100232 }))
      ])
      const getResData = resData => {
        return timeType === 'day' ? resData.data[0] : resData.data
      }
      if (res.success && getResData(res).length) {
        valueObj.activeEnergy = getResData(res)[0].value
      }
      if (res1.success && getResData(res1).length) {
        const v = ((valueObj.activeEnergy - getResData(res1)[0].value) / getResData(res1)[0].value) * 100
        valueObj.activeEnergyYoYpercent = v ? v.toFixed(2) : 0
      }
      if (res2.success && getResData(res2).length) {
        const v = ((valueObj.activeEnergy - getResData(res2)[0].value) / getResData(res2)[0].value) * 100
        valueObj.activeEnergyMoMpercent = v ? v.toFixed(2) : 0
      }
      if (res3.success && getResData(res3).length) {
        valueObj.activeEnergyR = getResData(res3)[0].value
      }
      if (res4.success && getResData(res4).length) {
        valueObj.reactiveEnergy = getResData(res4)[0].value
      }
      if (res5.success && getResData(res5).length) {
        valueObj.reactiveEnergyR = getResData(res5)[0].value
      }
      this.obj = valueObj
      vm.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.homocycle-ratio-warp {
  width: 100%;
  height: 100%;
  .box {
    display: flex;
    flex-flow: column;
    padding: 0px 4px;
    box-sizing: border-box;
    .item-title {
      height: 30px;
      line-height: 30px;
      display: flex;
      align-items: center;
      font-weight: bold;
    }
    .item-value {
      flex: 1;
      font-size: 28px;
      text-align: center;
      display: flex;
      font-weight: bold;
      white-space: normal;
      align-items: center;
      justify-content: center;
    }
    .item-foot {
      display: flex;
      height: 30px;
      line-height: 30px;
      div {
        flex: 1;
      }
      .item-foot-right {
        text-align: right;
      }
    }
  }
}
.icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 16px;
  margin-right: 4px;
  text-align: center;
  line-height: 20px;
}
.h-100 {
  height: 100%;
}
.icon-item {
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background: #fff;
  display: inline-block;
  line-height: 16px;
  text-align: center;
}
</style>
